"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = require("./styled");
const StyledList = props => {
    const { withScroll, children } = props;
    return ((0, jsx_runtime_1.jsx)(styled_1.StyledMuiList, { withScroll: withScroll, ...props, children: children }));
};
exports.StyledList = StyledList;
//# sourceMappingURL=index.js.map